import React from "react";
import { Link } from "react-router-dom";

const LatestNewsItems = ({ newsItems }) => {
  if (!newsItems || newsItems.length === 0) {
    return null;
  }

  const formatEventDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    const day = date.getDate();
    const year = date.getFullYear();

    const month = date.toLocaleString("en-US", { month: "short" });

    const getOrdinalSuffix = (n) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
  };

  const renderTitleWithBreaks = (text) => {
    return text.split(/<br\s*\/?>/i).map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split(/<br\s*\/?>/i).length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const moreButtonText = 'More News & Events';

  return (
    <section className="progress-section latest-news-second-section py-5">
      <div className="container position-relative">
        <div className="row latest-news-overall-wrapper">
          {newsItems.slice(0, 4).map((item, index) => (
            <div className="col-lg-3 col-12 mb-4" key={index}>
              <a
                className="single-news-wrapper text-decoration-none"
                data-sal="slide-up"
                data-sal-duration="500"
                data-sal-delay={100 + index * 200}
                href={`/news-details/${item.slug}`}
                style={{ cursor: "pointer" }}
              >
                <img src={`${process.env.REACT_APP_WEB_URL}${item.thumbnail}`} alt={`news-${index}`} />
                <div className="single-news-content ps-2 ps-md-5">
                  <p>
                    {renderTitleWithBreaks(item.title)}
                  </p>
                  <span>
                    <i>{formatEventDate(item.event_date)}</i>
                  </span>
                </div>
              </a>
            </div>
          ))}
          <div className="col-12 text-center mt-2 ln-btn-wrapper">
            <Link to="/newslist" className="about-btn">
              {moreButtonText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LatestNewsItems;
